<h1 i18n>Conversion Archive</h1>

@if (oldestAvaToAvaConversionPresent()) {
  <div>
    <p>
      Oldest AVAtoAVA conversion present:
      {{ oldestAvaToAvaConversionPresent() | date : 'dd.MM.yyyy' }}
    </p>
  </div>
}

<mat-form-field class="days-to-keep-input" appearance="fill">
  <mat-label>Days To Keep</mat-label>
  <input matInput placeholder="Positive Integer" [(ngModel)]="daysToKeep" />
</mat-form-field>

<button
  mat-button
  mat-raised-button
  color="primary"
  (click)="scheduleArchiving()"
  [disabled]="!daysToKeep || daysToKeep < 0 || requestEnRoute()"
  >
  Schedule AVAtoAVA conversions for Archiving
</button>

<hr />

@if (oldestGaebToAvaConversionWithoutPersistencePresent()) {
  <div>
    <p>
      Oldest GAEBtoAVA conversion without persisted files present:
      {{ oldestGaebToAvaConversionWithoutPersistencePresent() | date : 'dd.MM.yyyy' }}
    </p>
  </div>
}

<mat-form-field class="days-to-keep-input" appearance="fill">
  <mat-label>Days To Keep</mat-label>
  <input matInput placeholder="Positive Integer" [(ngModel)]="daysToKeepGaebToAva" />
</mat-form-field>

<button
  mat-button
  mat-raised-button
  color="primary"
  (click)="scheduleArchivingGaebToAva()"
  [disabled]="!daysToKeepGaebToAva || daysToKeepGaebToAva < 0 || requestEnRoute()"
  >
  Schedule GAEBtoAVA conversions for Archiving
</button>
